export const loginConstants = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',

  RESET_MESSAGE: 'RESET_MESSAGE'
};
